<template>
  <el-row class="container">
    <el-col class="container-col">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="我馆展览" name="first">
          <child1></child1>
        </el-tab-pane>
        <el-tab-pane label="对外交流" name="second">
          <child2></child2>
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </el-row>
</template>
<script>
  import Mychange from '@/pages/exhibitioninfo/mychange'
  import Waichange from '@/pages/exhibitioninfo/waichange'
  export default {
    components: {
      child1: Mychange,
      child2: Waichange,
    },
    data() {
      return {
        activeName: 'first',
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
    }
  };
</script>


<style scoped>
  .container {
    background: #FFFFFF;
    border-radius: 10px;
    width: 100%;
  }

  .container-col {
    padding: 20px 30px;
  }

  .el-tabs__item {
    font-size: 16px !important;
  }

  .submits {
    position: fixed;
    top: 92%;
    left: 90%;
    width: 0;
  }

  .Newly {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/pages/exhibitioninfo/exchange.vue